export const checkDomainThenRedirect = () => {
  if (window.location.host === process.env.REACT_APP_OLD_HOST) {
    window.location.replace(`${process.env.REACT_APP_NEW_DOMAIN}${window.location.pathname}`);
  }
};
